// Local translations
export const T = {
  en_GB: {
    // Dialog
    editTitle: "Edit Portfolio Collection",
    createTitle: "Add New Portfolio Collection",
    editDescription: "Update the portfolio collection information.",
    createDescription: "Choose a template to get started quickly, or create a blank collection.",
    // Templates
    chooseTemplate: "Choose a template",
    templateStandard: "Standard",
    templateStandardSubtitle: "3 ETFs · risk-scored",
    templateStandardDescription:
      "Three-fund allocation across global equity, European equity, and EUR government bonds. If you attach a risk model, one portfolio is created per risk score; otherwise only the products are added.",
    templateStandardDefaultName: "Standard Portfolios",
    templateBlank: "Blank",
    templateBlankSubtitle: "Start from scratch",
    templateBlankDescription:
      "Create an empty collection and configure products and portfolios manually.",
    // Form
    name: "Name",
    namePlaceholder: "e.g., Conservative Portfolios",
    description: "Description",
    descriptionPlaceholder: "Optional description",
    riskModel: "Risk Model",
    riskModelPlaceholder: "Select a risk model (optional)",
    noRiskModel: "No risk model",
    riskModelCannotChange: "Risk model cannot be changed after creation",
    riskModelSetOnceHint: "Once set, the risk model cannot be changed.",
    riskModelHint:
      "Optional. Required only if you want to create portfolios mapped to risk levels.",
    currency: "Currency",
    currencyHint:
      "Prices and amounts in this collection use this currency. It can't be changed later.",
    // Errors
    somethingWentWrong: "Something went wrong",
    failedToUpdate: "Failed to update portfolio collection",
    failedToCreate: "Failed to create portfolio collection",
    // Actions
    cancel: "Cancel",
    save: "Save",
    create: "Create",
  },
  nb_NO: {
    // Dialog
    editTitle: "Rediger porteføljesamling",
    createTitle: "Legg til ny porteføljesamling",
    editDescription: "Oppdater informasjonen for porteføljesamlingen.",
    createDescription: "Velg en mal for å komme raskt i gang, eller opprett en tom samling.",
    // Templates
    chooseTemplate: "Velg en mal",
    templateStandard: "Standard",
    templateStandardSubtitle: "3 ETFer · risikogradert",
    templateStandardDescription:
      "Tre-fonds allokering på tvers av global aksje, europeisk aksje og EUR statsobligasjoner. Hvis du tilknytter en risikomodell, opprettes én portefølje per risikoskår; ellers legges kun produktene til.",
    templateStandardDefaultName: "Standard porteføljer",
    templateBlank: "Tom",
    templateBlankSubtitle: "Start fra bunnen",
    templateBlankDescription:
      "Opprett en tom samling og konfigurer produkter og porteføljer manuelt.",
    // Form
    name: "Navn",
    namePlaceholder: "f.eks. Konservative porteføljer",
    description: "Beskrivelse",
    descriptionPlaceholder: "Valgfri beskrivelse",
    riskModel: "Risikomodell",
    riskModelPlaceholder: "Velg en risikomodell (valgfritt)",
    noRiskModel: "Ingen risikomodell",
    riskModelCannotChange: "Risikomodell kan ikke endres etter opprettelse",
    riskModelSetOnceHint: "Når den er satt, kan ikke risikomodellen endres.",
    riskModelHint:
      "Valgfritt. Påkrevd kun hvis du vil opprette porteføljer koblet til risikonivåer.",
    currency: "Valuta",
    currencyHint:
      "Priser og beløp i denne samlingen bruker denne valutaen. Den kan ikke endres senere.",
    // Errors
    somethingWentWrong: "Noe gikk galt",
    failedToUpdate: "Kunne ikke oppdatere porteføljesamling",
    failedToCreate: "Kunne ikke opprette porteføljesamling",
    // Actions
    cancel: "Avbryt",
    save: "Lagre",
    create: "Opprett",
  },
} as const;
